export * from './lib/chakraUi/themeConfig';
